import axios from 'axios';
import { serverConfig } from './server-config';

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Auth token has expired or is invalid, delete it from local storage
      localStorage.removeItem('authToken');
      location.reload();
    }
    return Promise.reject(error);
  }
);
export const MasterDataService = {
  getAllCities: () => {
    return axios.get(`https://${serverConfig.serverBaseAddress}/signite/data/cities`, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    });
  },
  getAllUgDegrees: () => {
    return axios.get(`https://${serverConfig.serverBaseAddress}/signite/data/ug_degrees`, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    });
  },
  getAllPgDegrees: () => {
    return axios.get(`https://${serverConfig.serverBaseAddress}/signite/data/pg_degrees`, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    });
  },
  getAllCountries: () => {
    return axios.get(`https://${serverConfig.serverBaseAddress}/signite/data/countries`, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    });
  },
  getPinDetail: (pin) => {
    return axios.get(`https://${serverConfig.serverBaseAddress}/signite/data/pin/` + pin, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    });
  },
  getAllLanguages: () => {
    return axios.get(`https://${serverConfig.serverBaseAddress}/signite/data/languages`, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    });
  },
  getAllIndustrySectors: () => {
    return axios.get(`https://${serverConfig.serverBaseAddress}/signite/data/industry-sectors`, {
      // headers: {
      //   Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      // },
    });
  },
  getIndustrySubcategories: (industrySectorId) => {
    return axios.get(
      `https://${serverConfig.serverBaseAddress}/signite/data/industry-sector/${industrySectorId}/sub-categories`,
      {
        // headers: {
        //   Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        // },
      }
    );
  },
  getAllFunctions: () => {
    return axios.get(`https://${serverConfig.serverBaseAddress}/signite/data/functions`, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    });
  },
  getFunctionSubcategories: (functionId) => {
    return axios.get(
      `https://${serverConfig.serverBaseAddress}/signite/data/function/${functionId}/sub-categories`,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },
  getAllSubscriptionTypes: () => {
    return axios.get(`https://${serverConfig.serverBaseAddress}/signite/data/subscription-types`, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    });
  },
  getAllPaymentTypes: () => {
    return axios.get(`https://${serverConfig.serverBaseAddress}/signite/data/payment-types`, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    });
  },

  addCity: (city, state) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/data/add/city`,
      {
        city: city,
        state: state
      },
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },

  addUgDegree: (ugDegreeName) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/data/add/ug`,
      {
        ugDegreeName: ugDegreeName
      },
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },

  addPgDegree: (pgDegreeName) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/data/add/pg`,
      {
        pgDegreeName: pgDegreeName
      },
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },
};
